export default __webpack_public_path__ + "static/media/googlestoreQr.c1105f29.png";